import { getBaseURLByENV } from '@/utils/net'

// 开票明细 表单
const formCfg = [{
    label: '开票请求日期'
}, {
    label: '开票抬头'
}, {
    label: '红/蓝票',
    invoice: [{
        text: '全部',
        value: ''
    }, {
        text: '蓝票',
        value: '0'
    }, {
        text: '红票',
        value: '1'
    }]
}, {
    label: '税率',
    tax_rate: [{
        text: '全部',
        value: ''
    },
        {
            text: '0%',
            value: '0%'
        },
        {
            text: '1.5%',
            value: '1.5%'
        },
        {
            text: '3%',
            value: '3%'
        },
        {
            text: '5%',
            value: '5%'
        },
        {
            text: '6%',
            value: '6%'
        },
        {
            text: '11%',
            value: '11%'
        },
        {
            text: '13%',
            value: '13%'
        },
        {
            text: '17%',
            value: '17%'
        },
    ]
}, {
    label: '发票代码'
}, {
    label: '发票号码'
}]

//开票明细 详情 table 表头
const detailColumns = [{
    title: '货物或应税劳务、服务名称',
    dataIndex: 'name',
    key: 'name',
},
    {
        title: '规格型号',
        dataIndex: 'models',
        key: 'models',
    },
    {
        title: '单位',
        dataIndex: 'unit',
        key: 'unit'
    },
    {
        title: '数量',
        dataIndex: 'total',
        key: 'total',
        sorter: (a, b) => {
            return a.total - b.total
        },
    },
    {
        title: '单价(不含税)',
        dataIndex: 'price',
        key: 'price',
        sorter: (a, b) => {
            return a.price - b.price
        }
    },
    {
        title: '金额(不含税)',
        dataIndex: 'total_price',
        // dataIndex: 'discount_no_tax',
        key: 'total_price',
        // key: 'discount_no_tax',
    },
    {
        title: '税率(%)',
        dataIndex: 'tax_rate',
        key: 'tax_rate',
        // filters: [{
        //     text: '0%',
        //     value: '0%'
        // },
        //     {
        //         text: '3%',
        //         value: '3%'
        //     },
        //     {
        //         text: '5%',
        //         value: '5%'
        //     },
        //     {
        //         text: '6%',
        //         value: '6%'
        //     },
        //     {
        //         text: '11%',
        //         value: '11%'
        //     },
        //     {
        //         text: '13%',
        //         value: '13%'
        //     },
        //     {
        //         text: '17%',
        //         value: '17%'
        //     },
        // ],
        // onFilter: (value, record) => {
        //     return record.tax_rate.includes(value)
        // },
    },
    {
        title: '税额',
        dataIndex: 'tax_amount',
        // dataIndex: 'dis_tax',
        key: 'tax_amount',
        // key: 'dis_tax',
        className: 'action',
    }
];

const redColums = [
    '货物或应税劳务、服务名称',
    '发票行性质',
    '规格型号',
    '单位',
    '数量',
    '单价',
    '金额',
    '税率(%)',
    '税额'
]


const appid = 'wx078f0866eeb53869';

// https://shanghu-dev.fapiaoer.cn
const devAppid = 'wx6e03cb99dac81373';

const yunpiaoAppid = 'wx8dd94c7ca602a306'

export default {
    formCfg,
    detailColumns,
    redColums,
    appid,
    devAppid,
    yunpiaoAppid
}
